import React, {useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import './Validation.css'

import AuthContext from "./AuthContext";
import {useNavigate} from "react-router-dom";
import backIng from "../Images/chineseink.jpg";



const RegisterForm = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();

    const Auth = useContext(AuthContext)
    const navigate = useNavigate()
    const onSubmit =  async (data) =>{
        // const res = await api.create(data)
        // if(data.Password === data.PasswordAgain){
        //
        //     // Navigate("/")
        // }
    }

    useEffect(()=>{
        
    },[])

    return (
        <div className="formBack"  >
            <h2 className="SingLabel RegLeb">Sing Up</h2>
        <form className="regForm" onSubmit={handleSubmit(onSubmit)}>
            <div className="inFormReg">
            <input className="inp" type="text" placeholder="Username" {...register("Username", {required: true, max: 32, maxLength: 80,} )} />
            <div className="erroer">{errors.Username && "This field is required"}</div>
            <input className="inp" type="text" placeholder="Email" {...register("Email", {required: true, pattern: /^\S+@\S+$/i})} />
            <div className="erroer"> {errors.Email &&"This field is required"}</div>
            <input className="inp"  type="password" placeholder="Password" {...register("Password", {required: true, max: 32, min: 7, maxLength: 32})} />
             <div className="erroer">{errors.Password &&"This field is required"}</div>
            <input className="inp" type="password" placeholder="Password Again" {...register("PasswordAgain", { required: true, max: 32, min: 7, maxLength: 32})} />
             <div className="erroer">{errors.PasswordAgain && "This field is required"}</div>
            <input  className="inp butSub" type="submit" value="Sing up"/>
            </div>
            <div className="Question regQuestion" >Already have an account?&nbsp;  <a className="linkA"
                                                                        onClick={(event)=>{
                                                                            event.preventDefault()
                                                                            navigate('/login')
                                                                        }}>  Sing in</a> </div>


        </form>
        </div>
    );
};

export default RegisterForm;